import { Component } from "react";

import { Project, ProjectService } from "@app/projects";
import { AccordionContainer } from "@app/shared";
import { TableType } from "@app/viewable-fields";
import { ViewableProviderFields } from "./ViewableProviderFields";

interface DisplayOptionsProps {
  defaultOpen: boolean;
  viewablePanels: TableType[];
  projectId: number;

  onChange: (displayOptionsDirty: boolean) => void;
  providerFields?: string[];
  relevantTableType?: TableType;
}

interface DisplayOptionsState {
  customProviderFields: string[];
  error: Error;
  hideDetails: boolean;
  openedViewableFields: boolean;
  project: Project;
}

class DisplayOptions extends Component<DisplayOptionsProps, DisplayOptionsState> {
  private readonly projectService = new ProjectService();

  constructor(props: DisplayOptionsProps) {
    super(props);

    this.state = {
      customProviderFields: props.providerFields,
      error: null,
      hideDetails: false,
      openedViewableFields: false,
      project: null,
    };
  }

  public async componentDidMount() {
    try {
      if (this.props.projectId) {
        const project: Project = await this.projectService.getById(this.props.projectId);

        this.setState({
          project,
        });
      } else {
        const hideDetails = true;

        this.setState({
          hideDetails,
        });
      }

    } catch (error) {
      this.setState({ error });
    }
  }

  public render() {
    return (this.state.project || null) && (
      this.renderForm()
    );
  }

  private renderForm() {
    const title = this.state.project.resource ? "Your display options for Project: " + this.state.project.resource.name : "";

    return (
      <>
        <div className={this.state.hideDetails ? "d-none" : ""}>
          <p> {title}</p>
        </div>
        <AccordionContainer>
          {this.props.viewablePanels.map((item) => this.renderViewablePanels(item))}
        </AccordionContainer>
      </>
    );
  }

  private renderViewablePanels = (viewablePanel: TableType) => {
    return (
      <ViewableProviderFields
        defaultOpen={viewablePanel === this.props.relevantTableType}
        key={viewablePanel}
        onChange={this.props.onChange}
        project={this.state.project}
        tableType={viewablePanel}
      />
    );
  }

}

export { DisplayOptions };
